// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__274Uj","selected":"Chip_selected__3bqBE"};